import { wait } from "./wait";

export async function retry<T>(
  functionToWrap: () => Promise<T> | T,
  maxNumberOfAttempts: number = 3,
  attemptDelayMs: number = 0
): Promise<T> {
  let remainingAttempts = maxNumberOfAttempts;
  let lastError: unknown;
  while (remainingAttempts-- > 0) {
    try {
      const result = functionToWrap();
      if (result instanceof Promise) {
        return await result;
      }
      return result;
    } catch (e) {
      if (attemptDelayMs > 0 && remainingAttempts > 0) {
        await wait(attemptDelayMs);
      }
      lastError = e;
    }
  }
  throw lastError;
}
